export const forIndividualsList = [
  "Keep tabs on loved ones during adventures with real-time tracking.",
  "Enhance family safety with continuous location updates.",
  "Enjoy the peace of mind that Trackmate provides."
]

export const forFleetsList = [
  "Maintain operational excellence with advanced telematics insights.",
  "Strengthen security with continuous, real-time monitoring.",
  "Streamline logistics and enhance efficiency across your fleet."
]